module.exports = __webpack_public_path__ + "img/5.06363fe2.png";